export default "__VITE_ASSET__BBeu$0WI__"